// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606170504/js/" + chunkId + "." + {"44":"1c4dda58","225":"ac9a5a74","481":"2376c01f","486":"1168f9a3","770":"0e45082a"}[chunkId] + ".0.6620501986956084.chunk.js";
};